(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3257],{

/***/ 73257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ AiDrivenCustomer_AiDrivenCustomer; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/AiDrivenCustomer/assets/AiDrivenCustomer@2x.png
var AiDrivenCustomer_2x = __webpack_require__(54089);
var AiDrivenCustomer_2x_default = /*#__PURE__*/__webpack_require__.n(AiDrivenCustomer_2x);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/AiDrivenCustomer/assets/AiDrivenCustomer.webp
var AiDrivenCustomer = __webpack_require__(22919);
var AiDrivenCustomer_default = /*#__PURE__*/__webpack_require__.n(AiDrivenCustomer);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/AiDrivenCustomer/assets/AiDrivenCustomer@2x.webp
var assets_AiDrivenCustomer_2x = __webpack_require__(17971);
var assets_AiDrivenCustomer_2x_default = /*#__PURE__*/__webpack_require__.n(assets_AiDrivenCustomer_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/AiDrivenCustomer/AiDrivenCustomerImage.tsx







var SIZES = "501px, 1022px";

var AiDrivenCustomerImage = function AiDrivenCustomerImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((AiDrivenCustomer_default()), " 501w, ").concat((assets_AiDrivenCustomer_2x_default()), " 1080w"),
        sizes: SIZES
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        src: (AiDrivenCustomer_2x_default()),
        sizes: SIZES,
        alt: "Orchestrate Journeys",
        width: "501",
        height: "493",
        loading: "lazy"
      })]
    })
  });
};

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xvlaih0"
} : 0)("display:flex;flex-direction:column;justify-content:center;align-items:center;padding:0px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{height:100%;}" + ( true ? "" : 0));

/* harmony default export */ var AiDrivenCustomer_AiDrivenCustomerImage = (AiDrivenCustomerImage);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/AiDrivenCustomer/AiDrivenCustomer.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var copy = {
  heading: "Use AI to turn every customer interaction into a unique customer experience",
  description: "Ensure your customer engagement gets smarter and more tailored all the time with user-friendly predictive and generative AI that improves targeting and personalization for lower costs and higher conversion rates."
};
var AiDrivenCustomer_link = {
  text: "Explore Segment AI",
  url: "/solutions/ai/"
};
var features = [{
  heading: "Gain a deeper understanding of your customer with trusted data built on relationships",
  description: "Understand the nuances and complexities of every customer\u2019s relationship to your brand, their household, account teams, and the world around them with enriched and extended golden profiles."
}, {
  heading: "Put accessible and actionable AI at marketers\u2019 fingertips",
  description: "Quickly and easily launch precisely targeted and timely campaigns\u2014without the help of data teams\u2014by putting the power of predictive AI directly in the hands of marketers."
}, {
  heading: "Create, activate, and iterate faster for better results",
  description: "Build the most engaging campaigns in minutes with customer-aware generative AI that automates who to target, how to build the journey, and what messages will resonate best with real-time insights for better results."
}];

var OrchestrateJourneys = function OrchestrateJourneys() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionWrapper, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionCopy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          gap: "small",
          children: features.map(function (feature, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
              alignment: "left",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: feature.heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  children: feature.description
                })]
              })
            }, index);
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
        href: (0,getAbsoluteUrl/* default */.Z)(AiDrivenCustomer_link.url, pageConfig),
        children: AiDrivenCustomer_link.text
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AiDrivenCustomer_AiDrivenCustomerImage, {})
    })]
  });
};

var SectionWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1ekcvzl2"
} : 0)( true ? {
  name: "ajfln6",
  styles: "overflow-x:visible"
} : 0);

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1ekcvzl1"
} : 0)("direction:ltr;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{justify-self:end;max-width:440px;}" + ( true ? "" : 0));

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ekcvzl0"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

/* harmony default export */ var AiDrivenCustomer_AiDrivenCustomer = (OrchestrateJourneys);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/AiDrivenCustomer/index.ts


/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 54089:
/***/ (function(module) {

module.exports = "/_next/static/images/AiDrivenCustomer@2x-7580e4ea8f07f98c9ab3dfe600db3cdb.png";

/***/ }),

/***/ 22919:
/***/ (function(module) {

module.exports = "/_next/static/images/AiDrivenCustomer-036f84073aacad9ed3abcd776e894e3a.webp";

/***/ }),

/***/ 17971:
/***/ (function(module) {

module.exports = "/_next/static/images/AiDrivenCustomer@2x-c74b3fccac008a6d06047e6d1038e649.webp";

/***/ })

}]);